import styled from 'styled-components';
import COLORS from '@styles/colors/themes/beam/beam2';

export const EmptyPageWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 50%);
  text-align: center;
  padding: 20px;
  font-family: 'Poppins' sans-serif;
  font-style: normal;
  width: 100%;
  display: grid;
  row-gap: 8px;
`;

export const EmptyPageHeading = styled.h3`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: ${COLORS.neutral.n901};
  margin: unset;
`;

export const EmptyPageMessage = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: ${COLORS.neutral.n800};
  margin: unset;
`;
